import { Theme } from '@lumahealthhq/ui-core';

const defaultProps = {
  disableGutters: true,
};

const styleOverrides = {
  root: ({ theme }: { theme: Theme }) => ({
    overflow: 'auto',
    backgroundColor: theme.palette.primary[25],
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: theme.spacing(3),
    '& > .MuiToolbar-root': {
      width: '100%',
      marginBottom: theme.spacing(3),
    },
    '& > .MuiPaper-root': {
      padding: theme.spacing(5),
      maxHeight: 'fit-content',
      minWidth: theme.breakpoints.values.sm,
      maxWidth: theme.breakpoints.values.sm,
      '& .MuiCardActions-root': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
      },
    },
    [theme.breakpoints.down('md')]: {
      '& > .MuiToolbar-root': {
        display: 'none',
      },
      '& > .MuiPaper-root': {
        minWidth: '100%',
        minHeight: '100%',
        maxHeight: 'none',
      },
    },
  }),
};

export default { defaultProps, styleOverrides };
